import {AudioService} from './audio.service';

export const AudioInjectables: Array<any> = [
  {provide: AudioService, useClass: AudioService},
];
